export const StandardLayoutType = 'standard';
export const MobileLayoutType = 'mobile';

const LayoutTypes = [
  StandardLayoutType,
  MobileLayoutType,
];

export default LayoutTypes;
